module.exports = __webpack_public_path__ + "img/dialog-rocket.2be8bac1.png";